// What a venue's board request leaves on screen. The terminal polls every
// minute; each answer replaces the last one's status, so a venue that was
// pending and then fails shows the failure, not "first collection in progress".

import { NotPublished, type Board } from "./api";

export interface BoardLoad {
  /** The last board that loaded; kept through a failed refresh. */
  board: Board | null;
  /** The latest request failed (other than 404); null once one succeeds. */
  error: string | null;
  /** The latest request got 404: the venue's first collection is still running. */
  pending: boolean;
}

export const EMPTY_LOAD: BoardLoad = { board: null, error: null, pending: false };

export type BoardLoadEvent = { type: "reset" } | { type: "loaded"; board: Board } | { type: "failed"; error: unknown };

export function boardLoad(state: BoardLoad, event: BoardLoadEvent): BoardLoad {
  switch (event.type) {
    case "reset":
      return EMPTY_LOAD;
    case "loaded":
      return { board: event.board, error: null, pending: false };
    case "failed":
      if (event.error instanceof NotPublished) return { ...state, error: null, pending: true };
      return {
        ...state,
        error: event.error instanceof Error ? event.error.message : String(event.error),
        pending: false,
      };
  }
}
